<template lang="pug">
    .component-simple-columns2.row

        .columns.n1.small-6
            slot(name="n1")
        .columns.n2.small-6
            slot(name="n2")


</template>
<script type="text/babel">
    export default {
        name: "simpleColumns2",
        components: {},
        data() {
            return {}
        },
        created() {
        },
        methods: {
            actionClicked() {
                this.$emit('actionClicked')
            },
            bulletsClicked() {
                this.$emit('bulletsClicked')
            }
        },
        computed: {},
        props: ['showBullets', 'showAction']
    }
</script>

<style lang="sass" rel="stylesheet/sass">
    .action
        cursor: pointer
</style>


// WEBPACK FOOTER //
// simpleColums2.vue?5617a05c